module.exports = {"520328004":"湄江街道","520328005":"黄家坝街道","520328006":"鱼泉街道","520328101":"永兴镇","520328102":"复兴镇","520328103":"马山镇","520328106":"高台镇","520328107":"茅坪镇","520328108":"兴隆镇","520328109":"新南镇","520328110":"石莲镇","520328111":"西河镇","520328112":"洗马镇","520328113":"抄乐镇","520328114":"天城镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520328.json
// module id = 2605
// module chunks = 0